// Requête de calcul d'une étude (extrait de la Step 5 le 03/11/2026 : le rapport relance le calcul quand le commercial
// change une marge)
import axios from 'axios'
import { authenticationService } from '@/services/authentication'
import { conf } from '@/config/config'

/**
 * Choix du matériel envoyés au serveur : panneau de la Step 2, toitures (typologie, système d'intégration, puissance
 * installable, nombre de carports), options de la Step 4 (03/11/2026).
 */
export function materielDeLEtude(s: any): any {
  const m = JSON.parse(JSON.stringify(s.materiel || {}))
  m.panneau = s.panneauCatalogue || ''
  const toitures = s.modeleProduction === 'pvgis' && Array.isArray(s.toitures) && s.toitures.length
    ? s.toitures.map((t: any) => ({ typologie: t.typologie || 'inclinee', integration: t.integration || '', kwcMax: t.kwc || 0,
      unites: t.typologie === 'carport' ? (t.unites || 1) : null }))
    : [{ typologie: s.typologie || 'inclinee', integration: s.integrationToiture || '', kwcMax: s.puissanceTotaleKwc || 0,
      unites: s.typologie === 'carport' ? (s.unitesCarport || 1) : null }]
  // toitures sans puissance connue (étude d'avant le 03/11/2026) : le serveur garde l'ancien calcul
  m.toitures = toitures.every((t: any) => t.kwcMax > 0) ? toitures : []
  m.bornes = (m.bornes || []).filter((b: any) => b && b.ref && b.nombre > 0)
  m.bacAcierM2 = m.bacAcier ? m.bacAcierM2 : null
  return m
}

/** Paramètres de la requête de calcul, depuis l'état de l'étude (store du wizard). */
export function payloadEtude(s: any): any {
  const payload: any = {
    // le serveur enregistre lui-même le résultat de l'étude (26/10/2026)
    draftId: s.draftId || null,
    projectName: s.projectName,
    clientType: s.clientType,
    clientLastName: s.clientLastName,
    clientFirstName: s.clientFirstName,
    address: s.address,
    latitude: s.latitude,
    longitude: s.longitude,
    puissanceMaxKwc: s.puissanceTotaleKwc,
    puissanceModuleWc: s.puissanceModuleWc,
    orientation: s.orientation,
    inclinaisonDeg: s.inclinaisonDeg,
    modeleProduction: s.modeleProduction,
    orientationDegres: s.orientationDegres,
    mountingplace: s.mountingplace,
    pvProfileId: s.pvProfileId || null,
    typeTarif: s.typeTarif,
    tarifHP: s.tarifHP,
    tarifHC: s.tarifHC,
    tarifHPHiver: s.tarifHPHiver,
    tarifHCHiver: s.tarifHCHiver,
    tarifHPEte: s.tarifHPEte,
    tarifHCEte: s.tarifHCEte,
    tarifAbonnementAnnuel: s.tarifAbonnementAnnuel,
    taxeelec: s.taxeelec,
    periodesHC: s.periodesHC,
    // heures super creuses (lot 8)
    tarifHSC: s.tarifHSC,
    tarifHSCHiver: s.tarifHSCHiver,
    tarifHSCEte: s.tarifHSCEte,
    periodesHSC: s.periodesHSC,
    periodesHCEte: s.periodesHCEte,
    periodesHCHiver: s.periodesHCHiver,
    periodesHSCEte: s.periodesHSCEte,
    periodesHSCHiver: s.periodesHSCHiver,
    inflationElec: s.inflationElec,
    capaciteUtilisableBatterie: s.capaciteUtilisableBatterie,
    // puissances de charge / décharge de la batterie calculées par le serveur (règle du 12/10/2026)
    puissanceAbonnement: s.puissanceAbonnement || null,
    degradationPanneaux: s.degradationPanneaux,
    degradationBatterie: s.degradationBatterie,
    rendementBatterie: s.rendementBatterie,
    rendementConversionBatterie: s.rendementConversionBatterie,
    coutInstallationPV: s.coutInstallationPV,
    coutInstallationBatterie: s.coutInstallationBatterie,
    rachatSurplusUnitaire: s.rachatSurplusUnitaire,
    zeroInjection: s.zeroInjection || false,
    coutRaccordementEnedis: s.coutRaccordementEnedis || 0, // € (k€ avant le 12/10/2026)
    travauxSupplementaires: s.travauxSupplementaires || 0,
    travauxSupplementairesLibelle: s.travauxSupplementairesLibelle || '',
    prixDatalogger: s.prixDatalogger != null ? s.prixDatalogger : null,
    // câble onduleur ↔ TGBT (19/10/2026) : section et prix calculés par le serveur pour chaque scénario
    longueurCable: s.longueurCable || null,
    erp: !!(s.erp && s.clientType !== 'Particulier'),
    prixCable: s.prixCable,
    prixRaccordsAlu: s.prixRaccordsAlu,
    raccordement: s.raccordement || null,
    // chiffrage au matériel (23/10/2026, provisoire) : coûts PV et batterie tirés du catalogue
    chiffrageMateriel: !!s.chiffrageMateriel,
    // panneau choisi en Step 2 (27/10/2026)
    materiel: materielDeLEtude(s),
    avecMaintenance: s.avecMaintenance,
    avecAssurance: s.avecAssurance !== false,
    coutMaintenance: s.coutMaintenance,
    coutAssurance: s.coutAssurance,
    hausseMaintenancePct: s.hausseMaintenancePct,
    hausseMaintenancePeriode: s.hausseMaintenancePeriode,
    inflationAssurance: s.inflationAssurance,
    avecFinancement: s.avecFinancement,
    apportPct: s.apportPct,
    tauxEmprunt: s.tauxEmprunt,
    dureeEmprunt: s.dureeEmprunt,
    dureeEmpruntAuPlusCourt: !!(s.avecFinancement && s.dureeEmpruntAuPlusCourt),
    pvRangeMin: s.pvRangeMin || 1,
    pvRangeMax: s.pvRangeMax || s.puissanceTotaleKwc,
    batRangeMin: s.batRangeMin !== null && s.batRangeMin !== undefined ? s.batRangeMin : 5,
    batRangeMax: s.batRangeMax || 25,
  }
  return payload
}

/**
 * Lance le calcul de l'étude (courbe enregistrée, profil prédéfini ou CSV de la séance) ; rend les résultats
 * (WizardBothResults). {@code surcharge} : paramètres remplacés (marges modifiées dans le rapport).
 */
export async function calculerEtude(s: any, surcharge?: any): Promise<any> {
  const headers = { Authorization: 'Bearer ' + authenticationService.status.jwtToken }
  const apiUrl = conf.API_URL
  const payload = { ...payloadEtude(s), ...(surcharge || {}) }
  if (s.consumptionCurveId) {
    payload.consumptionCurveId = s.consumptionCurveId
    return (await axios.post(apiUrl + '/simulation/optimize', payload, { headers })).data.data
  }
  if (s.profileSource === 'predefined') {
    payload.predefinedProfileKey = s.profilPredifini || 'maison_4pers'
    return (await axios.post(apiUrl + '/simulation/optimize', payload, { headers })).data.data
  }
  if (s.profileSource === 'csv' && s.csvFile) {
    const formData = new FormData()
    formData.append('file', s.csvFile)
    formData.append('params', JSON.stringify(payload))
    return (await axios.post(apiUrl + '/simulation/optimize-with-csv', formData,
      { headers: Object.assign({}, headers, { 'Content-Type': 'multipart/form-data' }) })).data.data
  }
  return (await axios.post(apiUrl + '/simulation/optimize', payload, { headers })).data.data
}

/**
 * Étude calculée enregistrée (statut terminé, réouverture sur le rapport) sans ses résultats, déjà dans leur table ;
 * résultats renvoyés seulement si le serveur ne les a pas enregistrés.
 */
export async function enregistrerEtudeCalculee(s: any, resultats?: any): Promise<void> {
  if (!s.draftId) return
  const headers = { Authorization: 'Bearer ' + authenticationService.status.jwtToken }
  const skip = new Set(['csvFile', 'simulationResult', 'resultSansBatterie', 'resultAvecBatterie', 'matrixResults'])
  const etat: any = {}
  Object.keys(s).forEach(k => { if (!skip.has(k)) etat[k] = s[k] })
  await axios.post(conf.API_URL + '/wizard/draft', { id: s.draftId, status: 'COMPLETED', customerId: null, stepReached: 6,
    projectName: s.projectName || '', wizardJson: JSON.stringify(etat) }, { headers })
  if (resultats && !resultats.resultatEnregistre) {
    await axios.post(conf.API_URL + '/wizard/draft/' + s.draftId + '/result', {
      draftId: s.draftId,
      sansBatterieJson: JSON.stringify(resultats.sansBatterie || null),
      avecBatterieJson: JSON.stringify(resultats.avecBatterie || null),
      matrixJson: JSON.stringify(resultats.matrix || []),
    }, { headers })
  }
}
